<script setup lang="ts">
const { initSmarticoError, isReadyGamefication } =
  storeToRefs(useSmarticoInit());

const { isGamificationLevelsActived } = storeToRefs(useSmarticoConfigs());

const loadComponent = computed(() => {
  return (
    isGamificationLevelsActived.value &&
    !initSmarticoError.value &&
    isReadyGamefication.value
  );
});
</script>

<template>
  <div :class="$style.centerPage">
    <SmarticoAlertsAndLoader
      v-if="!loadComponent"
      :force-show-error="!isGamificationLevelsActived"
    />
    <SmarticoApostatudoLevels v-else />
  </div>
</template>

<style module lang="postcss">
.centerPage {
  @apply w-full min-h-[600px] flex justify-center relative;
}
</style>
